import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  treeService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'authService',
    'additionalFieldService',
    'EQuickAccessItems',
    'EAdminFeatures',
    'EFeatures',
    'ETreeItemTypes',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      authService,
      AdditionalField,
      EQuickAccessItems,
      EAdminFeatures,
      EFeatures,
      ETreeItemTypes
    ) {
      'use strict';

      var folderWithParentDeferred = null;
      var treeServiceFactory = {};
      var canSendTreeCache = null;

      var loadingItem = {
        Name: $filter('translate')('CHILDREN LOADING'),
        TreeItemType: ETreeItemTypes.LOADING,
        HasPermission: true,
      };

      var quickAcessItems = [
        {
          Id: EQuickAccessItems.QUICKACCESS,
          Name: $filter('translate')('QUICKACCESS'),
          TreeItemType: ETreeItemTypes.QUICK_ACCESS,
          Features: [],
          IsOpen: true,
          HasChildren: true,
          HasPermission: true,
          CanShow: function () {
            return true;
          },
          Order: 0,
          Children: [
            {
              Id: EQuickAccessItems.MYDEADLINES,
              Name: $filter('translate')('MY DEADLINES'),
              TreeItemType: ETreeItemTypes.MY_DOCS_EXPIRED,
              Order: 1,
              Features: [],
              IsOpen: true,
              HasPermission: true,
              CanShow: function () {
                return true;
              },
            },
            {
              Id: EQuickAccessItems.CHECKOUTS,
              Name: $filter('translate')('CHECKOUTS'),
              TreeItemType: ETreeItemTypes.CHECKOUTS,
              Order: 2,
              Features: [],
              IsOpen: true,
              HasPermission: true,
              CanShow: function () {
                return true;
              },
            },
            {
              Id: EQuickAccessItems.SHAREDDOCUMENTS,
              Name: $filter('translate')('SHARED DOCS'),
              TreeItemType: ETreeItemTypes.SHARED_DOCUMENTS,
              Order: 3,
              Features: [],
              IsOpen: true,
              HasPermission: true,
              CanShow: function () {
                return true;
              },
            },
            {
              Id: EQuickAccessItems.FAVORITES,
              Name: $filter('translate')('FAVORITES'),
              TreeItemType: ETreeItemTypes.FAVORITES,
              Order: 4,
              Features: [],
              IsOpen: true,
              HasPermission: true,
              CanShow: function () {
                return true;
              },
            },
            {
              Id: EQuickAccessItems.DIGITALIZATIONS,
              Name: $filter('translate')('PROCESSING'),
              TreeItemType: ETreeItemTypes.PENDING_SCAN,
              Order: 5,
              Features: [],
              IsOpen: true,
              IsNew: true,
              HasPermission: true,
              CanShow: function () {
                const viewerServer = (webApiSettings.viewerServer || '').toUpperCase();

                return viewerServer === 'TESTE' || viewerServer === 'NOSSO';
              },
            },
          ],
        },
      ];

      function handleError(err, status) {
        if (status === 404) {
          var error = {
            error: $filter('translate')('SERVER OFFLINE'),
            error_description: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
          return error;
        }

        if (status !== 400) {
          var ex = {
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function getByIdFolder(idFolder) {
        var deferred = $q.defer();
        $http
          .get(`${webApiSettings.apiServiceBaseUri}treeview/${idFolder}`)
          .then((result) => {
            var treeItem = result.data;

            deferred.resolve(treeItem);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });
        return deferred.promise;
      }

      function getExpiredNotification() {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'treeview/getNotificationForMyDeadLines'
          )
          .then((result) => {
            var data = result.data;
            deferred.resolve(data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);

            deferred.reject(error);
          });
        return deferred.promise;
      }

      function getRepositories(removeQuickAccess) {
        var deferred = $q.defer();

        $http
          .get(webApiSettings.apiServiceBaseUri + 'treeview/repositories', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;

              data.forEach(function (c) {
                c.Children = null;
                c.HasPermission =
                  c.HasPermission === null ? false : c.HasPermission;
                c.Order = 1;
                c.CanShow = function () {
                  return true;
                };
                c.HasChildrens = function () {
                  var notRemoved =
                    c.Children &&
                    c.Children.filter(function (item) {
                      return (
                        !item.removed &&
                        !(item.TreeItemType === ETreeItemTypes.DOCUMENT_TYPE || item.TreeItemType === ETreeItemTypes.ADDITIONAL_FIELD)
                      );
                    });
                  if (
                    c.HasChildren &&
                    (c.Children === null || notRemoved.length > 0)
                  ) {
                    return true;
                  }
                };
              });

              var repositories = [{}];
              if (
                authService.authentication.email === 'autologin' ||
                removeQuickAccess
              ) {
                repositories = $filter('orderBy')(data, '+Name');
              } else {
                repositories = quickAcessItems.concat(
                  $filter('orderBy')(data, '+Name')
                );
                var trashCan = {
                  Id: EQuickAccessItems.TRASHCAN,
                  Name: 'TRASHCAN',
                  TreeItemType: 9,
                  Features: [],
                  IsOpen: true,
                  HasPermission: true,
                  ContextMenu: 'trashMenu',
                  CanShow: function () {
                    return authService.verifyHasAdminFeature([
                      EAdminFeatures.ManageTrashCan,
                    ]);
                  },
                  Order: 2,
                };
                repositories.push(trashCan);
              }

              deferred.resolve(repositories);
            },
            function (err) {
              var error = handleError(err.data, err.status);

              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function getChildren(folder) {
        var deferred = $q.defer();

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'treeview/children',
            folder,
            {
              ignoreLoadingBar: true,
            }
          )
          .then(
            function (result) {
              var data = result.data;
              data.forEach(function (c) {
                c.Children = null;
                c.CanShow = function () {
                  return true;
                };
                c.IdParent = folder.Id;
                c.TreeItemType = c.TreeItemType === null ? 1 : c.TreeItemType;
                c.HasPermission =
                  c.HasPermission === null ? false : c.HasPermission;
                c.CanSendFiles =
                  authService.isAdmin() === true ||
                  (c.Features !== undefined &&
                    c.Features !== null &&
                    c.Features.includes(EFeatures.SEND_DOCUMENT));
                c.HasChildrens = function () {
                  var notRemoved =
                    c.Children &&
                    c.Children.filter(function (item) {
                      return (
                        !item.removed &&
                        !(item.TreeItemType === ETreeItemTypes.DOCUMENT_TYPE || item.TreeItemType === ETreeItemTypes.ADDITIONAL_FIELD)
                      );
                    });
                  return (
                    c.HasChildren &&
                    (c.Children === null ||
                      notRemoved === undefined ||
                      notRemoved === null ||
                      notRemoved.length > 0)
                  );
                };
              });

              deferred.resolve(data);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function recursiveCreateSendFilesTree(items, parent) {
        if (parent !== undefined && parent !== null) {
          parent.name = parent.Name;
          parent.children = [];
          parent.toString = function () {
            return this.name;
          };
        }

        //Verifica se existem algum item que seja filho do 'parent'
        if (
          parent !== null &&
          parent !== undefined &&
          items.some(function (c) {
            return c.IdParent === parent.Id;
          })
        ) {
          // Insere os filhos
          parent.children = items.filter(function (c) {
            return c.IdParent === parent.Id;
          });
          parent.HasChildren = true;

          for (var i = 0, len = parent.children.length; i < len; i++) {
            var item = parent.children[i];

            item.name = item.Name;
            item.TreeItemType =
              item.TreeItemType === null ? ETreeItemTypes.FOLDER : item.TreeItemType;
            item.HasPermission =
              item.HasPermission === null ? false : item.TreeItemType;
            item.toString = function () {
              return this.name;
            };

            items.splice(items.indexOf(item), 1);
          }
        } else {
          return;
        }

        //Chama o create tree para cada um dos filhos
        parent.children
          .filter(function (c) {
            return c.TreeItemType !== ETreeItemTypes.LOADING;
          })
          .forEach(function (c) {
            recursiveCreateSendFilesTree(items, c);
          });
      }

      function recursiveCreateTree(items, parent) {
        //Verifica se existem algum item que seja filho do 'parent'
        if (
          parent !== null &&
          parent !== undefined &&
          items.some(function (c) {
            return c.IdParent === parent.Id;
          })
        ) {
          for (var i = 0, len = items.length; i < len; i++) {
            var c = items[i];

            c.TreeItemType = c.TreeItemType === null ? ETreeItemTypes.FOLDER : c.TreeItemType;
            c.HasPermission =
              c.HasPermission === null ? false : c.HasPermission;
            c.CanSendFiles =
              authService.isAdmin() === true ||
              (c.Features !== undefined &&
                c.Features !== null &&
                c.Features.includes(EFeatures.SEND_DOCUMENT));
          }

          // Insere os filhos
          parent.Children = items.filter(function (c) {
            return c.IdParent === parent.Id;
          });

          // Insere o carregando
          parent.Children.push(loadingItem);
        } else {
          return;
        }

        //Chama o create tree para cada um dos filhos
        parent.Children.filter(function (c) {
          return c.TreeItemType !== ETreeItemTypes.LOADING;
        }).forEach(function (c) {
          recursiveCreateTree(items, c);
        });
      }

      function getFolderWithAncestors(idFolder) {
        folderWithParentDeferred = $q.defer();
        if (idFolder) {
          $http
            .get(
              webApiSettings.apiServiceBaseUri +
                'treeview/ancestors/' +
                idFolder
            )
            .then(function (result) {
              var data = result.data;
              var first = data.filter(
                (c) => c.IdParent === undefined || c.IdParent === null
              )[0];

              data.forEach((item) => {
                item.CanShow = () => true;
              });

              recursiveCreateTree(data, first);

              if (folderWithParentDeferred !== null) {
                folderWithParentDeferred.resolve(first);
                folderWithParentDeferred = null;
              }
            })
            .catch((err) => {
              var error = handleError(err.data, err.status);

              folderWithParentDeferred.reject(error);
            });
        }

        return folderWithParentDeferred.promise;
      }

      function getFolderDocumentTypes(idFolder) {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'documentType/folderdocstypes/' +
              idFolder
          )
          .then((result) => {
            var data = result.data;
            deferred.resolve(data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);

            deferred.reject(error);
          });

        return deferred.promise;
      }

      function getDocumentTypeAdditionalFields(idDocumentType) {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'additionalField/fieldsByDocType/' +
              idDocumentType
          )
          .then(
            (result) => {
              var data = result.data;
              var fields = [];
              data = resolveReferences(data);
              if (Array.isArray(data)) {
                data.forEach(function (item) {
                  fields.push(new AdditionalField(item));
                });
              }

              deferred.resolve(fields);
            },
            function (err) {
              var error = handleError(err.data, err.status);

              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function getCanSendFolders() {
        var deferred = $q.defer();

        var now = new Date();

        var hourMilisecs = 1000 * 60 * 60;

        if (
          treeServiceFactory.canSendTreeCache !== null &&
          treeServiceFactory.canSendTreeCache.date.getTime() >
            now.getTime() - hourMilisecs
        ) {
          deferred.resolve(treeServiceFactory.canSendTreeCache.tree);
        }

        $http
          .get(
            webApiSettings.apiServiceBaseUri + 'treeview/canSendDocumentTree',
            {
              ignoreLoadingBar: true,
            }
          )
          .then(
            function (result) {
              var data = result.data;

              var repositories = data.filter(function (f) {
                return f.IdParent === undefined || f.IdParent === null;
              });

              repositories.forEach(function (r) {
                r.TreeItemType = ETreeItemTypes.REPOSITORY;
                if (r.HasPermission === undefined || r.HasPermission === null) {
                  r.HasPermission = false;
                }
              });

              repositories.forEach(function (r) {
                recursiveCreateSendFilesTree(data, r);
              });

              treeServiceFactory.canSendTreeCache = {
                date: now,
                tree: repositories,
              };

              deferred.resolve(repositories);
            },
            function (err) {
              var error = handleError(err.data, err.status);

              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function run() {
        try {
          treeServiceFactory.canSendTreeCache = canSendTreeCache;
          treeServiceFactory.loadingItem = loadingItem;
          treeServiceFactory.quickAcessItems = quickAcessItems;

          treeServiceFactory.getRepositories = logWrapper(
            getRepositories,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getChildren = logWrapper(
            getChildren,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getFolderWithAncestors = logWrapper(
            getFolderWithAncestors,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getCanSendFolders = logWrapper(
            getCanSendFolders,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getFolderDocumentTypes = logWrapper(
            getFolderDocumentTypes,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getDocumentTypeAdditionalFields = logWrapper(
            getDocumentTypeAdditionalFields,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getByIdFolder = logWrapper(
            getByIdFolder,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getExpiredNotification = logWrapper(
            getExpiredNotification,
            runtimeConstant.isDebugServicesInternals
          );

          return treeServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
